module.exports = __webpack_public_path__ + "static/media/slide-2.d46ec481.png";